<template>
  <el-form
      ref="form"
      :model="form">
    <el-form-item
        label="默认竞价"
        prop="defaultBid"
        label-width="76px"
        :rules="[
          { required: true, message: '请输入默认竞价', trigger: ['blur', 'change'] }
        ]">
      <gj-input
          v-model="form.defaultBid"
          width="150px">
        <template #prepend>{{adStore.SP.currencySymbol}}</template>
      </gj-input>
    </el-form-item>
    <el-radio-group
        v-model="form.targetType">
      <div
          class="flex"
          style="flex-direction: column; align-items: flex-start">
        <el-radio :label="AdGroupEnum.SP.targetingType.KEYWORD">
          关键词投放
          <div class="bid-type-help">选择有助于您的商品针对买家搜索展示关键词</div>
        </el-radio>
        <el-radio
            :label="AdGroupEnum.SP.targetingType.PRODUCT"
            class="product-target-radio">
          商品投放
          <div class="bid-type-help">选择特定商品、分类、品牌或者其他商品功能来定位您的广告</div>
        </el-radio>
      </div>

      <div class="picker-wrapper">
        <app-keyword-picker
            ref="keywordPicker"
            v-show="AdGroupEnum.SP.targetingType.KEYWORD === form.targetType"
            :market-id="marketId"
            :form="form.keywordPickerForm"
            title="关键词"
            :match-type-option="matchTypeOption"
            :ad-suggest-keyword$="adSuggestKeyword$"
            width="628px"
        ></app-keyword-picker>
        <app-product-target-picker
            ref="productTargetPicker"
            v-show="AdGroupEnum.SP.targetingType.PRODUCT === form.targetType"
            :market-id="marketId"
            :form="form.productTargetPickerForm"
            title="商品投放"
            width="628px"
            :ad-product$="adProduct$"
        ></app-product-target-picker>
      </div>
    </el-radio-group>
  </el-form>
</template>

<script>
  import {formMixin} from "../../../../../../../../minxins";
  import {AdGroupEnum, AdKeywordEnum} from "../../../../../common/enum";
  import AppKeywordPicker from "./keyword-picker";
  import AppProductTargetPicker from "./product-target-picker";
  import {getSpAdSuggestKeywordForAsinList, rankRecommendation} from "../../../../../../../../api/ad";
  import {identityArray, isMeaningless} from "../../../../../../../../utils/common";
  import {adStore} from "../../../../../common/store";

  export default {
    name: "app-keyword-bid-picker",
    components: {AppProductTargetPicker, AppKeywordPicker},
    mixins: [formMixin],
    props: {
      marketId: {
        required: true,
      },
      asinList: {
        required: true
      }
    },
    created() {},
    watch: {
      asinList: {
        handler(asinList, oldAsinList) {
          if (isMeaningless(asinList)
            || asinList.length === 0
            || identityArray(asinList, oldAsinList)) {
            return;
          }
          if (this.$refs['keywordPicker']) {
             this.refresh(asinList);
          } else {
            this.$nextTick(() => this.refresh(asinList));
          }
        },
        immediate: true
      },
      'form.defaultBid': {
        handler(defaultBid) {
          this.form.keywordPickerForm.bid = defaultBid;
          this.form.productTargetPickerForm.bid = defaultBid;
        },
        immediate: true
      }
    },
    data() {
      return {
        adSuggestKeyword$: null,
        adProduct$: null,
        AdGroupEnum: AdGroupEnum,
        AdKeywordEnum: AdKeywordEnum,
        adStore: adStore
      }
    },
    methods: {
      refresh(asins) {
        this.$refs['keywordPicker'].suggestKeywordLoading = true;
        // this.adSuggestKeyword$ = getSpAdSuggestKeywordForAsinList({
        //   marketId: this.marketId,
        //   asinList,
        // });
        this.adSuggestKeyword$ = {
          getData:rankRecommendation,
          params:{
            marketId: this.marketId,
            // campaignId:this.form.baseInfoForm.campaignId,
            // groupId: this.form.baseInfoForm.groupId,
            asins
          }
        };
        this.adProduct$ = Promise.resolve({
          records: asins.map(asin => ({asin}))
        });
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            if (valid) {
              if (AdGroupEnum.SP.targetingType.KEYWORD === this.form.targetType) {
                this.$refs['keywordPicker'].formValidate()
                  .then(() => resolve() )
                  .catch(() => reject() )
              }
              if (AdGroupEnum.SP.targetingType.PRODUCT === this.form.targetType) {
                this.$refs['productTargetPicker'].formValidate()
                  .then(() => resolve() )
                  .catch(() => reject() )
                
              }
            }else {
              reject()
            }
          });
        })
      }
    },
    computed: {
      matchTypeOption() {
        return AdKeywordEnum.SP.matchTypeOption.slice(0, 3)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "bid-picker";

  //.product-target-radio {
  //  display: block;
  //}

  .product-target-radio,
  .picker-wrapper {
    margin-top: 20px;
  }
  /deep/.gj-empty--img {
    display: block;
  }
  
</style>

